import { createSelector } from 'reselect'

import { formatPrices, formatStr, flatten } from './prices.helpers'
import { selectTaxValue } from './store/prices.selectors'

import {
  selectSelectedBundlesPrice,
  selectSelectedBundles,
  selectBundlesList,
} from '~/bundles/store/bundles.selectors'
import {
  selectTariffPrice,
  selectSortedTariffs,
  selectSelectedTariff,
  selectTariffKeys,
} from '~/tariff/store/tariff.selectors'

export const selectBundlesAndTariffPrice = createSelector(
  selectTariffPrice,
  selectSelectedBundlesPrice,
  selectTaxValue,
  (tariffsPrice, bundlesPrice, tax) => {
    const prices = tariffsPrice ? [...tariffsPrice, ...bundlesPrice] : []
    return formatPrices(prices, tax)
  },
)

export const selectTariffPriceFormatted = createSelector(
  selectTariffPrice,
  selectTaxValue,
  (price, tax) => {
    return formatPrices(price || [], tax)
  },
)

export const selectBundlesWithFormattedPrice = createSelector(
  selectSelectedBundles,
  selectTaxValue,
  (bundles, tax) => {
    return bundles.map((elem) => {
      const prices = formatPrices(elem?.price || [], tax)
      return {
        ...elem,
        durationText: formatStr(prices),
      }
    })
  },
)

export const selectBundlesListWithPrice = createSelector(
  selectBundlesList,
  selectTaxValue,
  (bundles, tax) => {
    return bundles.map((elem) => {
      const prices = formatPrices(elem?.price || [], tax)
      return {
        ...elem,
        durationText: formatStr(prices),
      }
    })
  },
)
export const selectTariffFinalPrice = createSelector(selectTariffPrice, (prices) => {
  const formatted = formatPrices(prices || [], 1)
  const finalTerm = formatted?.find((price) => price.duration.amount === 0)
  return finalTerm?.value
})

export const selectTariffsWithFormattedPrices = createSelector(
  selectSortedTariffs,
  selectTaxValue,
  (tariffs, tax) => {
    return tariffs.map((tariff) => ({ ...tariff, price: formatPrices(tariff.price || [], tax) }))
  },
)

export const selectSelectedTariffWithFormattedPrices = createSelector(
  selectSelectedTariff,
  selectTaxValue,
  (tariff, tax) => {
    return tariff ? { ...tariff, price: formatPrices(tariff.price || [], tax) } : undefined
  },
)

export const selectAllTariffsPrices = createSelector(
  (state) => state,
  selectTariffKeys,
  selectTaxValue,
  (state, keys, tax) => {
    const mappedTariffPrices = keys.map((key) => selectTariffPrice(state, key))
    const mappedBundlesPrices = keys.map((key) => selectSelectedBundlesPrice(state, key))
    const allPrices = [...flatten(mappedTariffPrices), ...flatten(mappedBundlesPrices)]
    return formatPrices(allPrices, tax)
  },
)
